export function hasCourseStarted(product, startsAt) {
  const isCourse = product === 'course'

  return isCourse && new Date(startsAt) < new Date()
}
